'use client'

import { useLocale, useTranslations } from 'next-intl'

import { useAirbridge } from '@/shared/config'
import { Button, Icon, Image, MobileLayout } from '@/shared/ui'
import LogoKorean from 'public/logo/logo-korean.svg'

import { Features } from './features'

export const ServiceFeatures = () => {
  const t = useTranslations('main.intro')
  const locale = useLocale()

  const airbridge = useAirbridge()

  const handleButtonClick = () => {
    airbridge.openDeeplink({
      type: 'click',
      deeplinks: {
        ios: 'spacev33m2://app?type=sk&idx=0',
        android: 'spacev33m2://app?type=sk&idx=0',
        desktop: `${window.location.origin}/guest/room`,
      },
      ctaParams: {
        cta_param_1: 'main',
        cta_param_2: 'view_available_rooms',
        cta_param_3: '',
      },
    })
  }

  return (
    <section>
      <MobileLayout className="px-6 pb-4">
        <h2 className="text-black *:block">
          <span className="typo-title3 font-normal">
            {t('subtitle.need_home')}
          </span>
          <span className="typo-title3 mb-5 font-bold">
            {t('subtitle.smart_choice')}
          </span>
          <div>
            {locale === 'ko' ? (
              <LogoKorean className="h-10 w-38" />
            ) : (
              <Image
                src="/image/logo_pc.png"
                alt="33m2"
                width={84}
                height={40}
                external={false}
                priority
                unoptimized
              />
            )}
            <span className="sr-only">삼삼엠투</span>
          </div>
        </h2>
      </MobileLayout>

      <Features />

      <MobileLayout className="px-6 pt-0">
        <Button
          variant="outline"
          color="secondary"
          size="large"
          fullWidth
          onClick={handleButtonClick}
        >
          {t('card_safe.button.find_unit')}
          <Icon name="arrow-right" size={16} strokeWidth={1} />
        </Button>
      </MobileLayout>
    </section>
  )
}
